import { useState, useEffect, useRef } from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowDown01Icon, CheckmarkCircle01Icon } from '@hugeicons/core-free-icons';

function FormSelect({ label, name, id, content, value, setValue }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const options = content || [];
    const selected = options.find(o => String(o.value) === String(value));
    const displayLabel = selected ? (selected.name || selected.text) : null;

    return (
        <div>
            <label htmlFor={id} className="form-label">{label}</label>
            <div ref={ref} className="relative mt-2">
                <button
                    type="button"
                    id={id}
                    onClick={() => setOpen(o => !o)}
                    className="appearance-none w-full flex items-center justify-between gap-2 px-3 h-10 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm sm:text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-400 dark:focus:border-blue-500 transition-colors"
                >
                    <span className={displayLabel ? 'text-slate-900 dark:text-gray-100' : 'text-slate-400 dark:text-gray-600'}>
                        {displayLabel || '-- select option --'}
                    </span>
                    <HugeiconsIcon
                        icon={ArrowDown01Icon}
                        size={14}
                        className={`text-gray-400 shrink-0 transition-transform duration-150 ${open ? 'rotate-180' : ''}`}
                    />
                </button>

                {open && (
                    <div className="absolute left-0 top-full mt-1 bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 py-1.5 z-50 w-full max-h-60 overflow-y-auto">
                        {options.map((item, index) => {
                            const optValue = item.value;
                            const optLabel = item.name || item.text;
                            const isSelected = String(optValue) === String(value);
                            return (
                                <button
                                    key={index}
                                    type="button"
                                    onClick={() => { setValue(optValue); setOpen(false); }}
                                    className={`w-full flex items-center justify-between gap-3 px-3 py-2 text-sm text-left transition-colors ${
                                        isSelected
                                            ? 'text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-500/10 font-medium'
                                            : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
                                    }`}
                                >
                                    <span>{optLabel}</span>
                                    {isSelected && (
                                        <HugeiconsIcon icon={CheckmarkCircle01Icon} size={14} className="text-blue-500 dark:text-blue-400 shrink-0" />
                                    )}
                                </button>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}

export default FormSelect;
